/* eslint-disable no-unused-vars */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import program from './components/routes/program/program-dux';
import programList from './components/routes/program-list/program-list-dux';
import recipientList from './components/routes/recipient-list/recipient-list-dux';
import awardFileList from './components/routes/award-file-list/award-file-list-dux';
import awardFile from './components/routes/award-file/award-file-dux';
import reports from './components/routes/reports/reports-dux.js';
import recipientDetail from './components/routes/recipient-detail/recipient-detail-dux.js';
import health from './components/routes/health/health-dux.js';
import settings from './components/routes/settings/settings-dux.js';

import app from './app-dux/app-dux';
import email from './app-dux/email-dux';
import globalization from './app-dux/globalization-dux';
import company from './app-dux/company-dux';
import roster from './app-dux/roster-dux';

/*******************************************************************************
 *  Gather all the reducers
 */
const reducer = combineReducers( {
    app,
    company,
    roster,
    email,
    globalization,
    program,
    programList,
    awardFileList,
    awardFile,
    reports,
    recipientList,
    recipientDetail,
    health,
    settings
} );

const middleware = [ thunk ];

//if ( window.location.port === '5000' ) {
    middleware.push( createLogger( {
        collapsed: true
    } ) );
//}

const AppStore = createStore(
    reducer,
    applyMiddleware( ...middleware )
);

export default AppStore;
